export const environment = {
  production: true,
  api_url_lambda: "https://a0ef6m9zyg.execute-api.us-west-1.amazonaws.com/prod/",
  api_url: "https://api.divineinfinitebeing.com/",
  frontend_url_backoffice: "https://www.backofficeportal.divineinfinitebeing.com/",
  frontend_url: "https://divineinfinitebeing.com/",
  astrology_api_url: "https://json.astrologyapi.com/v1/",
  // new_astrology_api_url:'https://df6rqy88v6l8f.cloudfront.net',
  new_astrology_api_url: 'https://wczfs5i4xwvt6h3g4z6jgcm4ei0rsvyp.lambda-url.us-east-1.on.aws',
  without_base_url:"https://i526y91jwg.execute-api.us-east-2.amazonaws.com/dev/",
  unauthorized_routes: [
    'user/login',
    'user/build-connection',
    'user-profile/fetch-profile-by-unique-name',
  ],
  confarence_room_base_url:"https://main.d1njtuljco40va.amplifyapp.com",
  positionstack_api_key:'f94b49d3a2592c82286e616abcb1b45d',
  positionstack_api_url:'http://api.positionstack.com/v1/forward',
  image_base_url:'https://all-frontend-assets.s3.amazonaws.com',
  ui_url: 'https://divineinfinitebeing.com/',
  // stripe_pub_key:"pk_test_51REPqTBSG7nojY7T0duOxJGy7UCDe4zm1flupxj54SEpDt47wBArjl9H9KxPgIPYkBUF3tvTEKPQxf702ObzhwAE00jacpyAVu",
  stripe_pub_key:"pk_live_51OJJgQBcRXKECv5fEDBmoqXYZjUe9YtTi3YpcOHvhhLH88hz49jfltqtlWf9RrzhrbmK1WvTjqv7XL3xYCOv6R4n00kBGGvOnX",
  environment_name: 'main',
  sequencial_lock:true,
  freeastrologyapiKey:['xStQbeVZHg1YkADubBPMj2gcIZXNhP7H2zUROHo7'],
  astrologyapi_keys: [
    'ak-f1696f4f4098d456876f1f52fdb6877e29b04221',
    'ak-936d0e0780db7f7c56ebf3cbc0dc3eb621f40342',
    'ak-b3f2fb194ecf3e2478f719912d3b666423d923c3',
  ],
};
